import React, { useEffect } from 'react'
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TransactionRow from 'modules/common/components/TransactionRow';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import * as actions from '../action';
import * as c from '../constant';

function PropertyLocationTab({ historyInfo, applicationId, getPropertyLocationLogs, dataInfo }) {

  useEffect(() => {
    getPropertyLocationLogs(applicationId, historyInfo.id);
  }, []);

  return (
    <div className="row p-3">
      <div className="col-12 mt-1 ml-2">
        <span className="title-color">Owner</span>
      </div>
      <div className="col-12 mt-3">
        <table className="transaction-table table table-borderless table-sm table-striped">
          <tbody>
            <TransactionRow
              title="Name"
              value={_.get(dataInfo, 'included.buildingOwner.attributes.full_name') || '--'}
            />
            <TransactionRow
              title="Telephone No."
              value={_.get(dataInfo, 'included.buildingOwner.attributes.telephone_no') || '--'}
            />
            <TransactionRow
              title="Address"
              value={_.get(dataInfo, 'included.buildingOwner.attributes.full_address') || '--'}
            />
            <TransactionRow
              title="TIN"
              value={_.get(dataInfo, 'included.buildingOwner.attributes.tin') || '--'}
            />
          </tbody>
        </table>
      </div>
      <div className="col-12 mt-3 ml-2">
        <span className="title-color">Property Location</span>
      </div>
      <div className="col-12 mt-3">
        <table className="transaction-table table table-borderless table-sm table-striped">
          <tbody>
            <TransactionRow
              title="No./Street"
              value={_.get(dataInfo, 'attributes.property_street') || '--'}
            />
            <TransactionRow
              title="Barangay"
              value={_.get(dataInfo, 'attributes.property_barangay_name') || '--'}
            />
            <TransactionRow
              title="District"
              value={_.get(dataInfo, 'attributes.property_district_name') || '--'}
            />
            <TransactionRow
              title="Province/City"
              value={_.get(dataInfo, 'attributes.property_province_name') || '--'}
            />
          </tbody>
        </table>
      </div>
      <div className="col-12 mt-3 ml-2">
        <span className="title-color">Administrator Beneficial</span>
      </div>
      <div className="col-12 mt-3">
        <table className="transaction-table table table-borderless table-sm table-striped">
          <tbody>
            <TransactionRow
              title="User"
              value={_.get(dataInfo, 'included.administratorBeneficialUser.attributes.full_name') || '--'}
            />
            <TransactionRow
              title="Telephone No."
              value={_.get(dataInfo, 'included.administratorBeneficialUser.attributes.telephone_no') || '--'}
            />
            <TransactionRow
              title="Address"
              value={_.get(dataInfo, 'included.administratorBeneficialUser.attributes.full_address') || '--'}
            />
            <TransactionRow
              title="TIN"
              value={_.get(dataInfo, 'included.administratorBeneficialUser.attributes.tin') || '--'}
            />
          </tbody>
        </table>
      </div>
    </div>
  )
}

PropertyLocationTab.defaultProps = {
  historyInfo: {},
  applicationId: ''
};

PropertyLocationTab.propTypes = {
  applicationId: PropTypes.string,
  historyInfo: PropTypes.instanceOf(Object),
  getPropertyLocationLogs: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataInfo: _.get(api, `${c.GET_PROPERTY_LOCATION_LOGS}.item`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_PROPERTY_LOCATION_LOGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PropertyLocationTab);
